import dynamic from 'next/dynamic';
import Loading from '@/components/Loading';
import { LAYOUT } from '@/constants/config';

const AboutIntro = dynamic(() => import('@/components/AboutUs/AboutIntro'), {
  ssr: false,
  loading: () => <Loading />,
});
const HotelSoftwareIntro = dynamic(
  () => import('@/components/AboutUs/HotelSoftwareIntro'),
  {
    ssr: false,
    loading: () => <Loading />,
  }
);
const OurFeatures = dynamic(() => import('@/components/AboutUs/OurFeatures'), {
  ssr: false,
  loading: () => <Loading />,
});
const OurTeam = dynamic(() => import('@/components/AboutUs/OurTeam'), {
  ssr: false,
  loading: () => <Loading />,
});
const OurTechnology = dynamic(
  () => import('@/components/AboutUs/OurTechnology'),
  {
    ssr: false,
    loading: () => <Loading />,
  }
);
const OurLocation = dynamic(() => import('@/components/AboutUs/OurLocation'), {
  ssr: false,
  loading: () => <Loading />,
});
const LiveDemoCTA = dynamic(() => import('@/components/AboutUs/LiveDemoCTA'), {
  ssr: false,
  loading: () => <Loading />,
});

export default function AboutPage() {
  return (
    <article className="about">
      <AboutIntro />
      <HotelSoftwareIntro />
      <OurTeam />
      <OurTechnology />
      <OurFeatures />
      <OurLocation />
      <LiveDemoCTA />
    </article>
  );
}

AboutPage.layout = LAYOUT.HEADER_NORMAL;
AboutPage.title = 'common.meta.page.about';
